import script from "./AdminWebinairesViews.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminWebinairesViews.vue?vue&type=script&setup=true&lang=js"

import "./AdminWebinairesViews.vue?vue&type=style&index=0&id=2ebf8a91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebf8a91"]])

export default __exports__